
export default {

  name:'elasticItems'
}
